<template>
  <div id="app">
    <keep-alive include="Index">
      <router-view class="content_view" />
    </keep-alive>
  </div>
</template>

<script>
export default {
  components: {},
  mounted() {},
  methods: {}
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
/* body::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

body::-webkit-scrollbar-track {
  --webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.3);
  border-radius: 10px;
}
body::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgb(99, 99, 99);
  --webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.3);
}

body::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
} */
</style>
